import React from 'react';
import { TouchableOpacity, View } from 'react-native';
import { useStyleSheet } from '../../hooks';
import { createStyleSheet } from '../../utils';
import { Text } from '../Text';
export function TabNavigation({ options, value, onChange, style }) {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: [styles.container, style] }, options.map(({ value: curValue, name }) => (React.createElement(TouchableOpacity, { key: curValue, onPress: () => {
            onChange(curValue);
        }, style: styles.period },
        React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: [styles.text, value === curValue ? styles.textSelected : {}] }, name),
        value === curValue && React.createElement(View, { style: styles.indicator }))))));
}
const getStyles = createStyleSheet(({ color, size }) => ({
    container: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderBottomColor: color.invert2.p4
    },
    text: { color: color.invert2.p56 },
    textSelected: { color: color.invert2.p100, fontWeight: '700' },
    period: {
        flexGrow: 1,
        paddingVertical: size.J,
        alignItems: 'center'
    },
    indicator: {
        height: 3,
        width: '100%',
        backgroundColor: color.primary.solid,
        position: 'absolute',
        bottom: -1,
        borderTopLeftRadius: 9999,
        borderTopRightRadius: 9999
    }
}));
//# sourceMappingURL=index.js.map